import React from 'react';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID';
const REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI || 'http://localhost:3000/oauth/google/callback';

const SocialLogin = () => {
  const handleGoogleLogin = () => {
    const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&response_type=code&scope=openid%20email%20profile`;
    window.location.href = url;
  };

  return (
    <div style={{ maxWidth: 400, margin: '0 auto 60px auto', padding: '0 36px', textAlign: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '20px 0', color: 'var(--text-tertiary)' }}>
        <div style={{ flex: 1, height: 1, backgroundColor: 'var(--border)' }}></div>
        <span style={{ fontSize: 12, fontWeight: 600 }}>또는 간편 로그인</span>
        <div style={{ flex: 1, height: 1, backgroundColor: 'var(--border)' }}></div>
      </div>
      
      <button 
        onClick={handleGoogleLogin} 
        className="modern-btn modern-btn-secondary" 
        style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 10, padding: 12 }}
      >
        <img 
          src="https://developers.google.com/identity/images/g-logo.png" 
          alt="google" 
          style={{ width: 18, height: 18, objectFit: 'contain' }} 
        />
        Google 계정으로 로그인
      </button>
    </div>
  );
};

export default SocialLogin;
